const raw =
  typeof document !== "undefined"
    ? document.documentElement.style.transform
    : "";

const transformProperty: "transform" | "WebkitTransform" =
  typeof raw === "string" && raw !== "" ? "transform" : "WebkitTransform";

export default transformProperty;
